import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs';
import { CurrentUserState } from '../store/current-user/current-user.state';

export const checkBillinGuard: CanActivateFn = (_route, _state) => {
  const store = inject(Store);

  const subscription$ = store.select(CurrentUserState.subscription);

  return subscription$.pipe(
    map((subscription) => subscription !== null && !subscription.freeTrialing),
  );
};
